"use server";

import { signIn, signOut } from "@/auth";
import { AuthError } from "next-auth";
import { db } from "@/lib/db";
import bcrypt from "bcryptjs";

export async function loginAction(
  _prev: { error?: string } | null,
  formData: FormData
): Promise<{ error: string } | null> {
  const email = formData.get("email") as string;
  const password = formData.get("password") as string;
  const base = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

  // Pre-check credentials so we can pick the right redirect target
  const user = await db.user.findUnique({ where: { email } });
  if (!user || !user.isActive || !(await bcrypt.compare(password, user.passwordHash))) {
    return { error: "Invalid email or password." };
  }

  const redirectTo = user.mustResetPassword ? `${base}/change-password` : `${base}/`;

  try {
    await signIn("credentials", { email, password, redirectTo });
    return null;
  } catch (error) {
    if (error instanceof AuthError) {
      return { error: "Invalid email or password." };
    }
    throw error; // rethrow NEXT_REDIRECT so Next.js handles it
  }
}

export async function signOutAction() {
  const base = process.env.NEXT_PUBLIC_BASE_PATH ?? "";
  await signOut({ redirectTo: `${base}/login` });
}
